import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';
import { media } from '../../../../styles/breakpoints-2026';

const { borderRadius, colors, spacing } = tokens;

const CELL_SIZE = 56;
const CELL_SIZE_COMPACT = 48;
const OVERLAP = spacing.xs;
const RING_WIDTH = 2;
const SILHOUETTE_SCALE = '80%';

export const stack = css`
  display: flex;
  flex: none;
`;

export const cell = css`
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  width: ${CELL_SIZE_COMPACT}px;
  height: ${CELL_SIZE_COMPACT}px;
  border: ${RING_WIDTH}px solid ${colors.neutral.surface.default};
  border-radius: ${borderRadius.inner};
  background-color: ${colors.neutral.subdued.default};

  & + & {
    margin-left: calc(${OVERLAP} * -1);
  }

  ${media('>=tablet')} {
    width: ${CELL_SIZE}px;
    height: ${CELL_SIZE}px;
  }
`;

export const photo = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const silhouette = css`
  && {
    width: auto;
    height: ${SILHOUETTE_SCALE};
    color: ${colors.secondary.trim.hover};
  }
`;
